module.exports = __webpack_public_path__ + "img/bf08de6.png";